import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AppThunk } from "../../store";
import { Version, VersionResponse } from "../../../api/generated/models";
import { IStandardError } from "../../../shared/types/error.types";
import { ApiService } from "../../../api/api.service";

export interface IVersionState {
  version: Version;
  versionError: IStandardError | null;
}

const initialState: IVersionState = {
  version: { version: null },
  versionError: null,
};

const versionSlice = createSlice({
  name: "version",
  initialState,
  reducers: {
    getVersionSuccess(state, action: PayloadAction<VersionResponse>) {
      state.version = action.payload;
      state.versionError = null;
    },
    getVersionFailed(state, action: PayloadAction<VersionResponse>) {
      const { version, errors } = action.payload;
      state.version = version;
      state.versionError = errors;
    },
  },
});

export const { getVersionSuccess, getVersionFailed } = versionSlice.actions;

export const fetchVersion = (): any => async (
  dispatch: (arg0: { payload: any; type: string }) => void,
  getState: any
) => {
  const apiService: ApiService = ApiService.getInstance();
  const { versionApi } = apiService;
  try {
    const results = await versionApi.getVersion();
    dispatch(getVersionSuccess(results));
  } catch (error) {
    dispatch(getVersionFailed(error));
  }
};

export default versionSlice.reducer;
